import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

const x = new Accordion('.accordion-container', {
    showMultiple: true,
});
